import React, { useState } from 'react';
import { Row } from 'tea-component';
import './index.scss';

interface IProps {
  className?: string
  style?: any
  children?: any
}


const CommonRow = (props: IProps) => {
  const { className = '', style, children, ...resetProps } = props || {}
  return (
    <Row className={className} style={style}>
      {React.Children.map(children, (child: any) => {
        return React.cloneElement(
          child,
          { ...resetProps }
        );
      })}
    </Row>
  );
};

export default CommonRow;
